/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
import { __awaiter, __generator } from "tslib";
import { StateTransforms } from '../transforms';
import { DataFormatProvider } from './provider';
export var ShapeFormatCategory = 'Shape';
export var PlyProvider = DataFormatProvider({
    label: 'PLY',
    description: 'PLY',
    category: ShapeFormatCategory,
    stringExtensions: ['ply'],
    parse: function (plugin, data) { return __awaiter(void 0, void 0, void 0, function () {
        var format, shape;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    format = plugin.state.data.build()
                        .to(data)
                        .apply(StateTransforms.Data.ParsePly, {}, { state: { isGhost: true } });
                    shape = format.apply(StateTransforms.Model.ShapeFromPly);
                    return [4 /*yield*/, format.commit()];
                case 1:
                    _a.sent();
                    return [2 /*return*/, { format: format.selector, shape: shape.selector }];
            }
        });
    }); },
    visuals: function (plugin, data) {
        var repr = plugin.state.data.build()
            .to(data.shape)
            .apply(StateTransforms.Representation.ShapeRepresentation3D);
        return repr.commit();
    }
});
export var BuiltInShapeFormats = [
    ['ply', PlyProvider],
];
